import { ASSETS } from 'src/common/utils/config';

export const UTM_MEDIUM_HOMEPAGE = 'homepage';
export const UTM_MEDIUM_EXPLORE_TAB = 'explore_tab';

export const visa2FlyFilters = {
  Trending: { popular: true },
  'Visa in 1 week': { maxDays: 7 },
};

export const v2fTaglines = [
  'End-to-end assistance',
  '9 out of 10 visas on time',
  'Real-time tracking',
];

export const tempCards = [
  {
    code: 'ML',
    name: 'Malaysia',
    image_url: ASSETS.BAGGAGE_DELAY,
    price: '₹4,400',
    sub_title: 'Processing time 1-2 business days',
    evisa: true,
  },
  {
    code: 'ET',
    name: 'Egypt',
    image_url: ASSETS.FLIGHT_DELAY,
    price: '₹8,100',
    sub_title: 'Processing time 3-4 business days',
    evisa: false,
  },
];

export const visaDiscounts = [
  {
    icon_url: ASSETS.YELLOW_DISCOUNT,
    title: 'Get <b>₹500 off</b> on your visa application',
    subtitle: 'Use code <b>ACKO500</b> for transactions above ₹5499',
  },
  {
    icon_url: ASSETS.YELLOW_DISCOUNT,
    title: 'Get <b>₹1000 off</b> on your visa application',
    subtitle: 'Use code <b>ACKO1000</b> for transactions above ₹18,999',
  },
];
